import React from 'react'
import {
  Box,
  ButtonPrimary,
  FormControl,
  FormLabel,
  Heading,
  Select,
  Text
} from 'front-end/src/components'
import { t, Trans } from '@lingui/macro'
import { useFormikContext } from 'formik'
import { InputControl } from 'formik-chakra-ui'
import { QUESTIONS_OPTIONS } from 'front-end/src/pages/auth/security-questions/SecurityQuestionsOptions'
import { SecurityQuestionsFormValues } from 'front-end/src/pages/auth/security-questions/SecurityQuestionsFormik'
import { brandColors } from 'shared/basicPalette'
import { staticLinks } from 'shared/linkBuilder'

const QUESTIONS_LABELS = [
  t`First question`,
  t`Second question`,
  t`Third question`
]

type SecurityQuestionsFormProps = {
  signupLoading: boolean
}

export const SecurityQuestionsForm: React.FC<SecurityQuestionsFormProps> = ({
  signupLoading
}) => {
  const { handleSubmit, isValid, values, setFieldValue } =
    useFormikContext<SecurityQuestionsFormValues>()

  const selectedQuestions = values.map((question) => question.question)
  const availableQuestions = QUESTIONS_OPTIONS.filter(
    (question) => !selectedQuestions.includes(question.value)
  )

  return (
    <form onSubmit={handleSubmit}>
      <Heading size="md">
        <Trans>Set a security questions</Trans>
      </Heading>
      <Text mt="12px">
        <Trans>
          Set you security questions to improve account security and
          recoverability.
        </Trans>
      </Text>

      <Box>
        {values.map((question, index) => {
          return (
            <FormControl mt="24px" key={`${question.question}-${index}`}>
              <FormLabel>{QUESTIONS_LABELS[index]}</FormLabel>
              <Select
                name={`question[${index}]`}
                options={availableQuestions}
                value={QUESTIONS_OPTIONS.find(
                  ({ value }) => question.question === value
                )}
                onChange={(opt) =>
                  setFieldValue(`[${index}]question`, opt?.value)
                }
              />
              <InputControl mt="16px" name={`[${index}]answer`} />
            </FormControl>
          )
        })}
      </Box>

      <ButtonPrimary
        disabled={!isValid}
        type="submit"
        isFullWidth
        mt="32px"
        isLoading={signupLoading}
      >
        <Trans>Sign in</Trans>
      </ButtonPrimary>

      <Box className="bottomLink">
        <Box color={brandColors.grey['700']} as={'a'} href={staticLinks.login}>
          <Trans>Cancel</Trans>
        </Box>
      </Box>
    </form>
  )
}
